// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import { Box, SpaceBetween, TextContent } from '@cloudscape-design/components';
import CopyableCodeView from '../CopyableCodeView';
import { PERSISTENT_PREREQUISITES, cdkInstallationCode } from '../constants';

const CdkInstallStep = () => {
  return (
    <SpaceBetween size="m">
      <Box>
        <TextContent>
          <h3>Prerequisites</h3>
          <ul>
            {PERSISTENT_PREREQUISITES.map((prereq) => (
              <li key={prereq}>{prereq}</li>
            ))}
          </ul>
        </TextContent>
      </Box>
      <Box>
        <TextContent>
          <p>Add the ResourceLens CDK constructs to your project:</p>
        </TextContent>
        <CopyableCodeView content={cdkInstallationCode} />
      </Box>
    </SpaceBetween>
  );
};

export default CdkInstallStep;
